import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/ui/Header';
import Button from '../../components/ui/Button';
import Icon from '../../components/AppIcon';
import HeroSection from './components/HeroSection';
import BenefitsSection from './components/BenefitsSection';
import TestimonialsSection from './components/TestimonialsSection';
import ProcessSection from './components/ProcessSection';
import StatisticsSection from './components/StatisticsSection';
import FAQSection from './components/FAQSection';
import Footer from './components/Footer';

const ISellCarLandingPage = () => {
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleGetStarted = () => {
    navigate('/vehicle-information-upload');
  };

  const handleLearnMore = () => {
    document.getElementById('benefits-section')?.scrollIntoView({ 
      behavior: 'smooth',
      block: 'start'
    });
  };

  return (
    <div className="min-h-screen bg-background">
      {/* Custom Header for Landing Page */}
      <header className="sticky top-0 z-50 bg-white/95 backdrop-blur-md border-b border-border shadow-sm">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center justify-between h-16 px-4 lg:px-6">
            {/* Logo */}
            <div className="flex items-center">
              <div className="flex items-center space-x-2">
                <div className="w-10 h-10 bg-gradient-to-br from-blue-600 to-blue-700 rounded-xl flex items-center justify-center shadow-lg">
                  <Icon name="Car" size={24} color="white" />
                </div>
                <span className="text-2xl font-bold bg-gradient-to-r from-blue-600 to-blue-800 bg-clip-text text-transparent">
                  iSell.car
                </span>
              </div>
            </div>

            {/* Desktop Navigation */}
            {/* <nav className="hidden md:flex items-center space-x-8">
              <a href="#how-it-works" className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors">
                How It Works
              </a>
              <a href="#benefits" className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors">
                Benefits
              </a>
              <a href="#testimonials" className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors">
                Reviews
              </a>
              <a href="#faq" className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors">
                FAQ
              </a>
            </nav> */}

            {/* CTA Buttons */}
            {/* <div className="hidden md:flex items-center space-x-4">
              <Button variant="outline" onClick={() => navigate('/offer-tracking-dashboard')}>
                Sign In
              </Button>
              <Button onClick={handleGetStarted} iconName="ArrowRight" iconPosition="right">
                Get My Offer
              </Button>
            </div> */}

            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="md:hidden p-2 text-muted-foreground hover:text-foreground transition-colors"
            >
              <Icon name={isMenuOpen ? "X" : "Menu"} size={20} />
            </button>
          </div>

          {/* Mobile Navigation */}
          {isMenuOpen && (
            <div className="md:hidden border-t border-border bg-white">
              <div className="py-4 px-4 space-y-4">
                <a href="#how-it-works" className="block text-sm font-medium text-muted-foreground hover:text-foreground transition-colors">
                  How It Works
                </a>
                <a href="#benefits" className="block text-sm font-medium text-muted-foreground hover:text-foreground transition-colors">
                  Benefits
                </a>
                <a href="#testimonials" className="block text-sm font-medium text-muted-foreground hover:text-foreground transition-colors">
                  Reviews
                </a>
                <a href="#faq" className="block text-sm font-medium text-muted-foreground hover:text-foreground transition-colors">
                  FAQ
                </a>
                <div className="pt-4 border-t border-border space-y-3">
                  <Button variant="outline" fullWidth onClick={() => navigate('/offer-tracking-dashboard')}>
                    Sign In
                  </Button>
                  <Button fullWidth onClick={handleGetStarted} iconName="ArrowRight" iconPosition="right">
                    Get My Offer
                  </Button>
                </div>
              </div>
            </div>
          )}
        </div>
      </header>

      {/* Main Content */}
      <main>
        <HeroSection onGetStarted={handleGetStarted} onLearnMore={handleLearnMore} />
        <BenefitsSection />
        <TestimonialsSection />
        <ProcessSection onGetStarted={handleGetStarted} />
        <StatisticsSection />
        <FAQSection />
        
        {/* Final CTA Section */}
        <section className="py-20 bg-gradient-to-br from-blue-50 to-indigo-50">
          <div className="max-w-4xl mx-auto px-4 lg:px-6 text-center">
            <h2 className="text-3xl lg:text-4xl font-bold text-foreground mb-4">
              Ready to Sell Your Car?
            </h2>
            <p className="text-lg text-muted-foreground mb-8 max-w-2xl mx-auto">
              Join thousands of satisfied customers who've sold their cars quickly and easily with iSell.car
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button size="lg" onClick={handleGetStarted} iconName="ArrowRight" iconPosition="right">
                Get My Offer Now
              </Button>
              {/* <Button size="lg" variant="outline" onClick={() => navigate('/offer-tracking-dashboard')}>
                View Dashboard
              </Button> */}
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default ISellCarLandingPage;